import { GoogleLogo, MicrosoftLogo, YahooLogo } from '@approvalmax/ui';

import { sendClickEmailEvent } from './Content.helpers';
import { messages } from './Content.messages';

export const resendTimeout = 60;

export const resendTimeoutStorageKey = 'signupEmailResendTimeout';

export const emailServices = [
    {
        name: messages.openGmail,
        Logo: GoogleLogo,
        url: 'https://mail.google.com',
        onClick: () => sendClickEmailEvent('gmail'),
    },
    {
        name: messages.openYahoo,
        Logo: YahooLogo,
        url: 'https://mail.yahoo.com',
        onClick: () => sendClickEmailEvent('yahoo'),
    },
    {
        name: messages.openOutlook,
        Logo: MicrosoftLogo,
        url: 'https://outlook.live.com/mail',
        onClick: () => sendClickEmailEvent('outlook'),
    },
];
